import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, ArrowUpRight } from "lucide-react";
import { toast } from "sonner";
import { api, setAdminToken, getAdminToken } from "@/lib/api";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    if (getAdminToken()) nav("/admin/dashboard", { replace: true });
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await api.post("/admin/login", { password });
      setAdminToken(res.data.token);
      toast.success("Welcome back, Todd.");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error("Incorrect password.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8F8F5] flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white border border-[#E2E8F0] p-10">
        <Link to="/" className="text-[10px] tracking-[0.22em] uppercase font-bold text-[#F97316] mb-8 inline-block">RVA Signs</Link>
        <div className="w-12 h-12 bg-[#1A1A1A] flex items-center justify-center">
          <Lock className="w-5 h-5 text-[#F97316]" />
        </div>
        <h1 className="font-heading text-3xl tracking-tight font-medium text-[#1A1A1A] mt-6">Admin sign in</h1>
        <p className="text-sm text-[#2B2F33]/70 mt-2">Lead inbox access for Todd.</p>

        <form onSubmit={submit} className="mt-8 space-y-6" data-testid="admin-login-form">
          <label className="block">
            <div className="text-[10px] tracking-[0.22em] uppercase text-[#2B2F33]/60 font-bold mb-2">Password</div>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoFocus
              data-testid="admin-password-input"
              className="w-full border-b border-[#E2E8F0] py-3 bg-transparent focus:outline-none focus:border-[#1A1A1A] transition-colors text-[#1A1A1A]"
            />
          </label>
          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="w-full bg-[#F97316] hover:bg-[#EA580C] disabled:opacity-60 text-white text-sm font-medium px-6 py-4 tracking-tight inline-flex items-center justify-center gap-2 transition-colors"
          >
            {submitting ? "Signing in..." : "Sign in"}
            <ArrowUpRight className="w-4 h-4" />
          </button>
        </form>

        <Link to="/" className="block text-center text-xs text-[#2B2F33]/60 mt-8 hover:text-[#1A1A1A]" data-testid="admin-back-home">
          &larr; Back to site
        </Link>
      </div>
    </div>
  );
}
